/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';


@Component({
    selector: 'dxo-key',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoKeyComponent extends NestedOption {
    @Input()
    get bing(): string {
        return this._getOption('bing');
    }
    set bing(value: string) {
        this._setOption('bing', value);
    }

    @Input()
    get google(): string {
        return this._getOption('google');
    }
    set google(value: string) {
        this._setOption('google', value);
    }

    @Input()
    get googleStatic(): string {
        return this._getOption('googleStatic');
    }
    set googleStatic(value: string) {
        this._setOption('googleStatic', value);
    }


    protected get _optionPath() {
        return 'key';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

}

@NgModule({
  declarations: [
    DxoKeyComponent
  ],
  exports: [
    DxoKeyComponent
  ],
})
export class DxoKeyModule { }
